import React, { Component } from 'react';

import * as Constants from '../../../constants/constants'
import { Card } from 'react-bootstrap'
import i18n from "../../../i18n";

const titleStyle = {
    backgroundColor: Constants.MAIN_COLOR,
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px"
}

export default class ValidationPolicy extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>

                <Card.Header style={titleStyle}>
                    {i18n.t("simple:" + this.props.data.policyName)}
                </Card.Header>

                <Card.Body className="border">
                    <Card.Text>
                        {i18n.t("simple:policy")}
                    </Card.Text>
                </Card.Body>

            </React.Fragment>
        );
    }
}